// Exact phrases (ordered: most specific first so longer matches win)
const DEFAULT_WAKE_PHRASES = [
  // Standard + punctuation variants
  'hey president lincoln',
  'hey, president lincoln',
  'hey president lincoln,',
  // Common mis-transcriptions
  'hey lincon',
  'hey linkin',
  'hey lincln',
  'hey linclon',
  'hey lincolm',
  'hey linkeln',
  'hey linkon',   // Indian-accent vowel shift
  'hey linkan',   // Indian-accent vowel shift
  'hey linkun',   // Indian-accent vowel shift
  'hey linc',     // truncated
  // "hi" variants (Indian English uses "hi" as naturally as "hey")
  'hi president lincoln',
  'hi, president lincoln',
  'hi linkin',
  'hi linkon',
  'hi linkan',
  // Title variants
  'hey president',
  'hey mr president lincoln',
  'hey mister president lincoln',
  'hey mr. president lincoln',
  // "Hello" variants
  'hello president lincoln',
  'hello mr president',
  'hello mr. president',
  'hello mister president',
  'hello president',
  'hello president lincoln',
  'hello mr president lincoln',
  'hello mr. president lincoln',
  'hello mister president lincoln',
  'hello lincon',
  'hello linkin',
  'hello linkon',
  // "Hey/Hi Mr President" variants
  'hey mr president',
  'hey mr. president',
  'hey mister president',
  'hi mr president',
  'hi mr. president',
  'hi mister president',
  // "Good morning/afternoon/evening" variants
  'good morning mr president',
  'good morning mr. president',
  'good morning mister president',
  'good morning president',
  'good afternoon mr president',
  'good afternoon president',
  'good evening mr president',
  'good evening president',
  // Trigger words Chrome produces for "hey" in some accents
  'ok president lincoln',
  'okay president lincoln',
  'hay president lincoln',
  'a president lincoln',
  'the president lincoln',
  'i president lincoln',
  'aye president lincoln',
];

export function findWakePhrase(text, wakePhrases = DEFAULT_WAKE_PHRASES) {
  const t = String(text || '').toLowerCase();

  // 1. Exact phrase match
  for (const p of wakePhrases) {
    const idx = t.indexOf(p);
    if (idx >= 0) return { phrase: p, idx };
  }

  // 2. Fuzzy phonetic match — catches Indian-accent and other accent variants.
  //    Matches any trigger word followed by something that starts with "linc" or "link".
  //    e.g. "hey lincon", "hi linkon", "a linkun", "okay lincan"
  const fuzzy = t.match(/\b(hey|hi|hello|ok|okay|hay|good\s+(?:morning|afternoon|evening)|a|the|i|aye|e|eh)\s+(mr\.?\s+|mister\s+)?(linc\w*|link\w*|president)/);
  if (fuzzy) {
    return { phrase: fuzzy[0], idx: fuzzy.index };
  }

  return null;
}

export function extractAfterWake(text, wakeMatch) {
  if (!wakeMatch) return '';
  const raw = String(text || '');
  const start = wakeMatch.idx + wakeMatch.phrase.length;
  return raw.slice(start).replace(/^[\s,.:;!?-]+/, '').trim();
}

